import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChevronLeft, ChevronRight, Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { createRef, memo, useState } from 'react';
import { PLP_IMAGE_SIZES } from '../../apps/collection/constants';
import css from './Images.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Images = function Images(_ref) {
  var images = _ref.images,
      url = _ref.url,
      title = _ref.title;

  var _useState = useState({
    next: true,
    previous: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      buttonsEnabled = _useState2[0],
      setButtonsEnabled = _useState2[1];

  var listEl = /*#__PURE__*/createRef(null);
  var firstChildEl = /*#__PURE__*/createRef(null);
  var total = images.length;
  var nextClass = cc([css.next, _defineProperty({}, css.on, buttonsEnabled.next)]);
  var previousClass = cc([css.previous, _defineProperty({}, css.on, buttonsEnabled.previous)]);

  if (images.length < 1) {
    return false;
  }

  var slide = function slide(dir) {
    var width = firstChildEl.current.offsetWidth;
    var currentLeft = listEl.current.scrollLeft;
    var totalWidth = total * width;
    var left = currentLeft + width * dir;
    setButtonsEnabled({
      next: left < totalWidth - width - 20,
      previous: left > 20
    });
    listEl.current.scrollTo({
      left: left,
      behavior: 'smooth'
    });
  };

  var onPrevious = function onPrevious(event) {
    event.preventDefault();
    slide(-1);
  };

  var onNext = function onNext(event) {
    event.preventDefault();
    slide(1);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("a", {
      "aria-label": "Click to view ".concat(title),
      href: url,
      className: css.list,
      ref: listEl,
      children: images.map(function (_ref4, idx) {
        var image = _ref4.image;
        return /*#__PURE__*/_jsx("div", {
          className: css.item,
          ref: idx === 0 ? firstChildEl : null,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
            alt: "".concat(title, " - ").concat(image.alt),
            sizes: PLP_IMAGE_SIZES,
            wrap: false
          }))
        }, image.id);
      })
    }), images.length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("button", {
        className: nextClass,
        onClick: onNext,
        disabled: !buttonsEnabled.next,
        "aria-label": "Click To Scroll To Next Image",
        type: "button",
        children: /*#__PURE__*/_jsx(ChevronRight, {})
      }), /*#__PURE__*/_jsx("button", {
        className: previousClass,
        onClick: onPrevious,
        disabled: !buttonsEnabled.previous,
        "aria-label": "Click To Scroll To Previous Image",
        type: "button",
        children: /*#__PURE__*/_jsx(ChevronLeft, {})
      })]
    })]
  });
};

Images.displayName = 'Images';
Images.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired
    })
  })).isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(Images);